import { Button } from "@/components/ui/button";
import type { AvailableAccount } from "@/hooks/use-accounts";
import { PlatformIcon } from "@/components/social/PlatformIcon";
import { useTranslation } from "react-i18next";

interface Props {
  account: AvailableAccount;
  onLink: () => void;
  busy?: boolean;
  disabled?: boolean;
}

export function AvailableAccountRow({ account, onLink, busy, disabled }: Props) {
  const { t } = useTranslation("settings");
  return (
    <div className="rounded-lg border p-3 flex items-center gap-3">
      <PlatformIcon platform={account.platform} size={32} className="rounded" />
      <div className="flex-1 min-w-0">
        <div className="truncate text-sm font-medium">{account.username ?? t("availableAccount.noHandle")}</div>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <span>{account.platform}</span>
          {account.profile && (
            <span>{t("availableAccount.fromProfile", { name: account.profile.name })}</span>
          )}
        </div>
      </div>
      <Button size="sm" onClick={onLink} disabled={busy || disabled}>
        {busy ? t("availableAccount.linking") : t("availableAccount.link")}
      </Button>
    </div>
  );
}
